import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './NotFoundPage.scss';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="not-found-page">
      <div className="container">
        <div className="not-found-content">
          <div className="error-number">404</div>
          <div className="error-icon">
            <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <circle cx="32" cy="32" r="30" stroke="currentColor" strokeWidth="4" fill="none"/>
              <line x1="22" y1="22" x2="42" y2="42" stroke="currentColor" strokeWidth="5" strokeLinecap="round"/>
              <line x1="42" y1="22" x2="22" y2="42" stroke="currentColor" strokeWidth="5" strokeLinecap="round"/>
            </svg>
          </div>
          <h1 className="error-title">Page Not Found</h1>
          <p className="error-description">
            The page you're looking for doesn't exist or has been moved. 
            Don't worry, even the best explorers sometimes take a wrong turn!
          </p>
          
          <div className="suggestions">
            <h3>Here are some helpful links:</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/events">Browse Events</Link></li>
              <li><Link to="/activities">Activities</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          <div className="error-actions">
            <button onClick={handleGoBack} className="btn btn-outline-primary">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Go Back
            </button>
            <Link to="/" className="btn btn-primary">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Go Home
            </Link>
          </div>

          <div className="search-section">
            <h3>Looking for something specific?</h3>
            <div className="search-box">
              <input 
                type="text" 
                placeholder="Search events, activities, or anything else..."
                className="search-input"
              />
              <button className="search-btn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
                  <path d="m21 21-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
